import { NgIf } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbModal, NgbModalRef, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoService } from "@ngneat/transloco";
import { ExternalCfsFeatureEvent, IframeMessageTypes } from "clearline-common";
import { QrCodeReaderModalComponent } from "../";

@Component({
  selector: "lib-qr-code-reader-button",
  templateUrl: "./qr-code-reader-button.component.html",
  styleUrls: ["./qr-code-reader-button.component.scss"],
  standalone: true,
  imports: [NgIf, NgbTooltipModule]
})
export class QrCodeReaderButtonComponent implements OnInit {
  @Input() buttonId = "";
  @Input() buttonText = "";
  @Input() buttonIcon = "fa fa-qrcode";
  @Input() useCustomScanner = false;
  @Input() isButtonDisabled = false;
  @Output() scanResult = new EventEmitter<string>();
  @Output() scanModalOpened = new EventEmitter<NgbModalRef>();
  @Output() customScanRequest = new EventEmitter<ExternalCfsFeatureEvent>();

  title = "";
  disabled = false;

  constructor(private modalSvc: NgbModal, private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.title = this.buttonText || this.translocoService.translateObject("qrcode.read");
  }

  openModal() {
    if (this.useCustomScanner) {
      // This warning needs to avoid confusions when the [Scan] button doesn't respond when clicked
      console.info("The system is configured to use a custom scanner");
      this.customScanRequest.emit({ eventType: IframeMessageTypes.buttonClick, targetId: this.buttonId });
    } else {
      this.openQrCodeReader();
    }
  }

  private openQrCodeReader(): void {
    this.disabled = true;
    const qrModal: NgbModalRef = this.modalSvc.open(QrCodeReaderModalComponent, {
      backdrop: "static",
      size: "l",
      centered: true,
      windowClass: "custom"
    });
    const comp: QrCodeReaderModalComponent = qrModal.componentInstance;

    this.scanModalOpened.emit(qrModal);
    comp.startScanning();
    qrModal.result.then(
      (result: string) => {
        this.scanResult.emit(result);
        this.disabled = false;
      },
      (error) => {
        this.scanResult.emit("");
        this.disabled = false;
      }
    );
  }
}
